// API notifiche lato Operatore Economico. Stesso shape dell'api PPP, ma punta
// al prefisso /api/v1/operatore (il backend filtra per utente in sessione).
import { useHttp } from '@veda/dashboard-ui';

const BASE = '/api/v1/operatore';

export function useNotificheOperatoreApi() {
  const { request, loading } = useHttp();

  const get = (url, cb) => request(url, { method: 'GET', ...cb });
  const put = (url, data, cb) => request(url, { method: 'PUT', body: JSON.stringify(data), ...cb });

  return {
    loading,
    listNotifiche: (params, cb) => {
      const qs = new URLSearchParams();
      if (params?.nonLette) qs.append('non_lette', '1');
      if (params?.perPage)  qs.append('per_page', params.perPage);
      const q = qs.toString() ? `?${qs.toString()}` : '';
      return get(`${BASE}/notifiche${q}`, cb);
    },
    contaNotifiche: (cb) => get(`${BASE}/notifiche/conta`, cb),
    marcaNotificaLetta: (id, cb) => put(`${BASE}/notifiche/${id}/letta`, {}, cb),
    marcaTutteNotificheLette: (cb) => put(`${BASE}/notifiche/tutte-lette`, {}, cb),
  };
}
